import { render, staticRenderFns } from "./inventory_detail.vue?vue&type=template&id=3fc09681&scoped=true"
import script from "./inventory_detail.vue?vue&type=script&lang=js"
export * from "./inventory_detail.vue?vue&type=script&lang=js"
import style0 from "./inventory_detail.vue?vue&type=style&index=0&id=3fc09681&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc09681",
  null
  
)

export default component.exports